export const PAGE_TITLES = {
  "/": "Inicio",
  "/login": "Inicio de Sesión",
  "/register": "Registro",
  "/terminos-y-condiciones": "Términos y Condiciones",
  "/aviso-de-privacidad": "Aviso de Privacidad",
  "/proximamente/agenda-nacional": "Próximamente — Agenda Nacional",
  "/proximamente/zettabyte": "Próximamente — Zettabyte",
  "/publicaciones/agenda-nacional": "Publicaciones — Agenda Nacional",
  "/publicaciones/circulo-rojo": "Publicaciones — Círculo Rojo",
  "/publicaciones/mercados": "Publicaciones — Mercados",
  "/publicaciones/zettabyte": "Publicaciones — Zettabyte",
  "/publicaciones/mananeras": "Publicaciones — Mañaneras",
  "/suscripcion/zettabyte": "Suscripción — Zettabyte",
  "/suscripcion/agenda-nacional": "Suscripción — Agenda Nacional",
  "/suscripcion/pago-exitoso": "Pago Exitoso",
  "/bloques/boletin": "Panel de Boletines",
  "/podcast": "Podcast — Nuestra Visión TV",
};

export const SCROLL_EVENTS = {
  DEPTH_25: 25,
  DEPTH_50: 50,
  DEPTH_75: 75,
  DEPTH_100: 100,
};

export const EXIT_EVENTS = {
  CLICK_EXIT_LINK: "click_exit_link",
};

export const SEARCH_EVENTS = {
  SITE_SEARCH: "site_search",
};

export const AUDIO_EVENTS = {
  PLAY: "audio_play",
  PAUSE: "audio_pause",
  ENDED: "audio_ended",
  SEEK: "audio_seek",
  MUTE: "audio_mute",
};

export const AUTH_EVENTS = {
  LOGIN_SUCCESS: "login_success",
  LOGIN_FAILED: "login_failed",
  LOGOUT: "logout",
  REGISTER_SUCCESS: "register_success",
};

export const SUBSCRIPTION_EVENTS = {
  START: "subscription_start",
  SUCCESS: "subscription_success",
  CANCEL_REQUEST: "subscription_cancel_request",
  CANCEL_CONFIRM: "subscription_cancel_confirm",
};

export const CONTENT_EVENTS = {
  SECTION_OPEN: "section_open",
  SECTION_CLOSE: "section_close",
  DOCUMENT_VIEW: "document_view",
  NOTE_READ: "note_read",
  BOLETIN_VIEW: "boletin_view",
  PDF_DOWNLOAD: "pdf_download",
  PDF_OPEN: "pdf_open",
  SCROLL_DOCUMENTOS: "scroll_documentos",
};
